import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import ARPTable from '../tables/distro/ARPTable';
import Typography from '@mui/material/Typography';
import BrokenLinkPage from './BrokenLinkPage';
import { useParams } from 'react-router-dom';
import { DistroNameDataType } from '../../types/buildingTypes';
import SwitchPortsTable from '../tables/distro/SwitchPortsTable';
import AccessSwitchTable from '../tables/access-switch/AccessSwitchTable';
import { useUserContext } from '../../context/userConext';
import { useRequiredSearchParams } from '../../hooks/useRequiredSearchParams';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from './pageStyles';

function DistroDhcpDevicesPage() {
  const { distro } = useParams<DistroNameDataType>();
  const { params, isValid } = useRequiredSearchParams(['region', 'building', 'vendor', 'site']);
  const { user_permissions } = useUserContext();

  if (!isValid || !distro) return <BrokenLinkPage />;

  const canPerformPortFlip = user_permissions.port_flip_mac_mini_action_permission;
  const canPerformPortBounce = user_permissions.port_bounce_mac_mini_action_permission;
  const canUseAccessSwitchTable = canPerformPortFlip && canPerformPortBounce;

  return (
    <>
      <Header />
      <Box sx={{ margin: 'auto', width: '80%' }}>
        <Box sx={pageStyles.dynamicBreadcrumbs}>
          <DynamicBreadcrumbs />
        </Box>
        <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
          Distro manager - IP: {distro}, Region: {params.region}
        </Typography>
        <ARPTable
          device="distro-dhcp"
          deviceIP={distro}
          selectedVendor={params.vendor}
          selectedSite={params.site}
          selectedRegion={params.region}
          selectedBuilding={params.building}
          isDhcpRole={true}
          hasPermissionsToCreateDhcpReservation={
            user_permissions.dhcp_reservation_create_permission
          }
          hasPermissionsToUpdateDhcpReservation={
            user_permissions.dhcp_reservation_update_permission
          }
          hasPermissionsToDeleteDhcpReservation={
            user_permissions.dhcp_reservation_delete_permission
          }
          hasPermissionsToBulkCreateDhcpReservation={
            user_permissions.dhcp_reservations_batch_create_permission
          }
        />
        {canUseAccessSwitchTable ? (
          <AccessSwitchTable
            device="distro"
            deviceIP={distro}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
            unlimitedPortBounce={false}
            unlimitedPortFlip={false}
          />
        ) : (
          <SwitchPortsTable
            device="distro"
            deviceIP={distro}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
          />
        )}
      </Box>
    </>
  );
}

export default DistroDhcpDevicesPage;
